export default class SavedItemsView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.saved-items-view');
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
